module.exports = __webpack_public_path__ + "static/img/02_寄放物品.875eb0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/02_寄放物品.png
// module id = mudL
// module chunks = 1